import React from 'react';
import MentorEditForm, { REQUIRED_COMMENT } from '../MentorEditForm';

// Mirrors the field set of CreateDevelopmentDialogue. Keep the two in step.
const FIELDS = [
    { name: 'strengths', label: 'Area(s) of Strength:', input: 'textarea', rules: REQUIRED_COMMENT },
    { name: 'improvement', label: 'Area(s) for Improvement:', input: 'textarea', rules: REQUIRED_COMMENT },
    { name: 'change', label: 'Career goals/status:', input: 'textarea', rules: REQUIRED_COMMENT },
    {
        name: 'skills_to_work_on',
        label: 'Specific skills or behavior to work on:',
        input: 'textarea',
        rules: REQUIRED_COMMENT
    },
    { name: 'followup_note', label: 'Plan for follow up:', input: 'textarea', rules: REQUIRED_COMMENT },
];

export default function EditDevelopmentDialogue({ employee, mentor, onSaved }) {
    return (
        <MentorEditForm
            title='Edit Development Dialogue'
            employee={employee}
            mentor={mentor}
            fields={FIELDS}
            onSaved={onSaved}
        />
    )
}
